import { omitBy, isEmpty, isNil, map } from 'lodash';

const model = (data: any) => {

    const items = map(data, itemObj => {
        let item = itemObj;
        return omitBy({
            inventoryID: item.productData.inventoryID,
            cartCode: item.cartID,
            orgID: item.productData.orgID,
            quantity: item.quantity,
            uom: item.selectedVariant.uom,
            variantName: item.selectedVariant.variantName,
            variantCode: item.selectedVariant.variantCode
        }, isNil)
    })

    return omitBy({
        items: items
    }, isNil);
}

export default model;
